import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const WHEEL_SIDE = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const WHEEL_SIDE_NAME = 'wheel_side';
export const WHEEL_SIDE_NAME_COMPLEMENTARY = 'wheel_side_complementary';

export const RadioGroupWheelSide: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ?? (isComplementary ? WHEEL_SIDE_NAME_COMPLEMENTARY : WHEEL_SIDE_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Z której strony znajduje się kierownica?')}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-wheel-side"
            >
              <RadioItem
                value={WHEEL_SIDE.LEFT}
                label={i18n.t('Standardowo, z lewej')}
                data-testid="radio-item-wheel-side-left"
              />
              <RadioItem
                value={WHEEL_SIDE.RIGHT}
                label={i18n.t('Z prawej (Anglik)')}
                data-testid="radio-item-wheel-side-right"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
